export type AnalyticsQueryArgs = {
  from?: string;
  to?: string;
  grain?: string;
  metric?: string;
  dimension?: string;
  applicationId?: string;
  agentName?: string;
  model?: string;
  limit?: number;
};

export function toQuery(args: AnalyticsQueryArgs = {}): string {
  const params = new URLSearchParams();
  if (args.from) params.set('from', args.from);
  if (args.to) params.set('to', args.to);
  if (args.grain) params.set('grain', args.grain);
  if (args.metric) params.set('metric', args.metric);
  if (args.dimension) params.set('dimension', args.dimension);
  if (args.applicationId) params.set('application_id', args.applicationId);
  if (args.agentName) params.set('agent_name', args.agentName);
  if (args.model) params.set('model', args.model);
  if (args.limit != null) params.set('limit', String(args.limit));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
